// i18n catalog — AdminPerformance page (namespace: perf.*)
// EN values copied VERBATIM from src/pages/AdminPerformance.js.
// AR = Modern Standard Arabic. The parent merges this into lib/i18n.js.
// Only STATIC UI copy is here — dynamic data, figures, currency, platform
// names and brand names are intentionally NOT translated.
export const en = {
  // SectionHdr title (AdminPerformance.js ~48)
  "perf.history.title": "Performance history",

  // StatCard labels (AdminPerformance.js ~50) — also used as chart series names
  "perf.stat.gross": "Gross",
  "perf.stat.netReceivable": "Net Receivable",
  "perf.stat.vat": "VAT",
  "perf.stat.cogs": "COGS",
  "perf.stat.trueProfit": "True Profit",

  // True-Profit StatCard sub: "avg <figure>/mo" (AdminPerformance.js ~51)
  // Split into static affix + suffix so the figure stays unwrapped.
  "perf.stat.avgPrefix": "avg ",
  "perf.stat.perMonthSuffix": "/mo",

  // Chart headings (AdminPerformance.js ~56,69,83)
  "perf.chart.trueProfitPerMonth": "True profit / month",
  "perf.chart.grossVsNet": "Gross vs net receivable",
  "perf.chart.netProfitPctTrend": "Net profit % trend",

  // Net-profit line series name (AdminPerformance.js ~91)
  "perf.series.netProfitPct": "Net Profit %",

  // filterLabel fallback when no channel selected (AdminPerformance.js ~45)
  "perf.filter.allPlatforms": "All platforms",
};

export const ar = {
  // SectionHdr title
  "perf.history.title": "سجل الأداء",

  // StatCard labels / chart series names
  "perf.stat.gross": "الإجمالي",
  "perf.stat.netReceivable": "صافي المستحق",
  "perf.stat.vat": "ضريبة القيمة المضافة",
  "perf.stat.cogs": "تكلفة البضاعة المباعة",
  "perf.stat.trueProfit": "الربح الحقيقي",

  // avg <figure>/mo — keep the numeric figure unwrapped between these affixes
  "perf.stat.avgPrefix": "متوسط ",
  "perf.stat.perMonthSuffix": "/شهر",

  // Chart headings
  "perf.chart.trueProfitPerMonth": "الربح الحقيقي / الشهر",
  "perf.chart.grossVsNet": "الإجمالي مقابل صافي المستحق",
  "perf.chart.netProfitPctTrend": "اتجاه نسبة صافي الربح",

  // Net-profit line series name
  "perf.series.netProfitPct": "نسبة صافي الربح",

  // filterLabel fallback
  "perf.filter.allPlatforms": "كل المنصات",
};
